import React, { FC } from 'react';
import styled from 'styled-components';
import { CalendarIntegration } from 'api/timesheets/integration/calendar-integration-provider';
import { Avatar } from 'components/atoms/avatar';
import { Popover as AtomPopover } from 'components/atoms/popover';
import { useTimesheetLogoutMutation } from 'queries/timesheets/calendar-integration-provider';
import { ProfileMenu } from './profile-menu';

interface ProfileProps {
  integration: CalendarIntegration;
  size?: number;
}

const Content = styled.div`
  cursor: pointer;
`;

export const Popover = styled(AtomPopover)`
  .ant-popover-inner-content {
    padding: var(--spacing-05) 0;
  }
  & {
    padding: 0;
  }
`;

export const Profile: FC<ProfileProps> = ({ integration, size = 32 }) => {
  const { mutateAsync } = useTimesheetLogoutMutation();
  const { meta, integrationId } = integration;
  const {
    oauthAuthenticatorEmail: email,
    oauthAuthenticatorAccountProfileUrl: photoUrl,
    oauthAuthenticatorAccountName: userName,
  } = meta;

  if (!email) {
    return null;
  }

  return (
    <Popover
      trigger="click"
      content={
        <ProfileMenu
          meta={meta}
          onClick={() => mutateAsync({ integrationId })}
        />
      }
    >
      <Content>
        <Avatar src={photoUrl} size={size} name={userName} />
      </Content>
    </Popover>
  );
};
